import { buildAuthHeaders, getClientBaseUrl } from "@client/trpc";

export async function getOrCreateUserId(email: string): Promise<string> {
  // Carry the native bearer token + use the absolute API base, so bundled iPad
  // builds (origin capacitor://localhost, no cookie) reach the API host and
  // authenticate. On web/server this is a no-op (empty base, no bearer).
  const headers: Record<string, string> = { ...buildAuthHeaders() };

  if (typeof window === "undefined") {
    // Only Bun/Node callers (scripts, tests) reach this branch — browsers
    // always have `window`. Read the secret from process.env, not
    // import.meta.env: Vite exposes only VITE_*-prefixed vars to the browser
    // bundle, and a secret must never gain that prefix.
    headers["Cookie"] =
      `ADD_OR_CREATE_USER_ID_SECRET=${process.env.ADD_OR_CREATE_USER_ID_SECRET}`;
  }

  const res = await fetch(
    `${getClientBaseUrl()}/api/getOrCreateUserId?email=${encodeURIComponent(email)}`,
    {
      headers,
    },
  );

  const { userId } = await res.json();

  return userId;
}
